module.exports = __webpack_public_path__ + "img/sku-icon.c0401bb.png";